import React, { FC, PropsWithChildren } from 'react';
import { getEnv, ENV_TYPE } from '@tarojs/taro';
import { CustomWrapper } from '@tarojs/components';
import classNames from 'classnames';
import View from '../view';

interface IListProps {
  className?: string;
  titleClassName?: string;
  index?: string;
  id?: string;
  key: string;
  customWrapper?: boolean;
}

const isWebEnv = getEnv() === ENV_TYPE.WEB;

const List: FC<PropsWithChildren<IListProps>> = ({ className = '', titleClassName = '', children, index, id, customWrapper: propsCustomWrapper = false }) => {
  const customWrapper = !isWebEnv && propsCustomWrapper;
  const rootClass = classNames('ink-indexes__list', className);
  const titleClass = classNames('ink-indexes__list-title', titleClassName);

  return (
    <View className={rootClass}>
      <View id={id} className={titleClass}>
        {index}
      </View>
      {customWrapper ? <CustomWrapper>{children}</CustomWrapper> : children}
    </View>
  );
};

export default List;
